import { actionTypes } from 'src/actions/actionTypes'

const initialState = {
  userDetails: {
    mobileNumber: null,
    pincode: null,
    gender: null,
    fullName: null,
    ageDetails: null,
  },
  proposerDetails: {},
  memberDetails: [],
  nomineeDetails: {},
  selectedQuote: {},
  selectedFullQuote: null,
  fullQuote: null,
  quickQuoteFilters: {
    sumInsured: 1000000,
    policyPeriod: 1,
  },
  providerDetails: {},
  token: null,
  trust: null,
  paymentLink: null,
  kycLink: null,
  planDetailsQuote: null,
  planDetails: null,
  comparePlanList: [],
  policyTenurePeriod: 1,
}

const buyPolicyReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_DETAILS:
      return { ...state, userDetails: action.payload }
    case actionTypes.UPDATE_MEMBER_DETAILS:
      return { ...state, memberDetails: action.payload }
    case actionTypes.UPDATE_SELECTED_QUOTE:
      return { ...state, selectedQuote: action.payload }
    case actionTypes.UPDATE_FULL_QUOTE:
      return { ...state, fullQuote: action.payload }
    case actionTypes.UPDATE_PROPOSER_DETAILS:
      return { ...state, proposerDetails: action.payload }
    case actionTypes.UPDATE_NOMINEE_DETAILS:
      return { ...state, nomineeDetails: action.payload }
    case actionTypes.UPDATE_TOKEN:
      return { ...state, token: action.payload }
    case actionTypes.UPDATE_QUICK_QUOTE_FILTERS:
      return { ...state, quickQuoteFilters: action.payload }
    case actionTypes.UPDATE_PROVIDER_DETAILS:
      return { ...state, providerDetails: action.payload }
    case actionTypes.UPDATE_SELECTED_FULL_QUOTE:
      return { ...state, selectedFullQuote: action.payload }
    case actionTypes.UPDATE_TRUST:
      return { ...state, trust: action.payload }
    case actionTypes.UPDATE_PAYMENT_LINK:
      return { ...state, paymentLink: action.payload }
    case actionTypes.UPDATE_KYC_LINK:
      return { ...state, kycLink: action.payload }
    case actionTypes.UPDATE_PLAN_DETAILS_QUOTE:
      return { ...state, planDetailsQuote: action.payload }
    case actionTypes.UPDATE_PLAN_DETAILS:
      return { ...state, planDetails: action.payload }
    case actionTypes.ADD_TO_COMPARE: {
      const compareList = [...state.comparePlanList]
      compareList.push(action.payload)
      return { ...state, comparePlanList: compareList }
    }
    case actionTypes.REMOVE_FROM_COMPARE: {
      const comparePlanList = [...state.comparePlanList]
      const quote = action.payload
      const index = comparePlanList.findIndex(
        (listItem) => listItem.enquiryId === quote.enquiryId
      )
      comparePlanList.splice(index, 1)
      return { ...state, comparePlanList: comparePlanList }
    }
    case actionTypes.CLEAR_COMPARE_LIST:
      return { ...state, comparePlanList: [] }
    case actionTypes.UPDATE_POLICY_TENURE:
      return { ...state, policyTenurePeriod: action.payload }
    case actionTypes.CLEAR_STATE:
      return { ...initialState }
    default:
      return state
  }
}

export default buyPolicyReducer
